import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './template.types';

export const templateSelectors = {
  ...generateResourceSelectors<types.ITemplate>((state) => state.resource.template),
};
